/** @format */

export default {
	SET_DOCUMENTS: 'SET_DOCUMENTS',
	SET_ERROR_FOR_DOCUMENTS: 'SET_ERROR_FOR_DOCUMENTS',
	SET_DOCUMENTS_SUMMARY: 'SET_DOCUMENTS_SUMMARY',
	SET_ERROR_FOR_DOCUMENTS_SUMMARY: 'SET_ERROR_FOR_DOCUMENTS_SUMMARY',
};
